import type { SideBarItemProps } from 'src/utils/advisor-dash-nav/side-bar';

const CLIENT_BASE_RE = /^\/advisor\/dashboard\/client\/[^/]+/;

// Overview is the only tab with no section of its own — it *is* the base route — so several places
// have to recognise it by title. Named here so renaming the tab can't silently disable one of them.
export const OVERVIEW_TAB_TITLE = 'Overview';

export function clientSectionPath(path: string): string | null {
  const withoutQuery = path.split(/[?#]/)[0] ?? '';
  if (!CLIENT_BASE_RE.test(withoutQuery)) return null;
  return withoutQuery.replace(CLIENT_BASE_RE, '');
}

// Shared with the breadcrumb label in `client-page-title-nav` so both match on the
// same boundary. Two independent substring checks silently disagree on a section whose
// path is a prefix of another's.
export function sectionMatches(currentSection: string, itemPath?: string): boolean {
  if (!itemPath) return false;
  const section = clientSectionPath(itemPath);
  if (section === null || section === '') return false;
  // Segment-boundary match, not a substring one: `/service-calendar` is a prefix of
  // `/service-calendar-v3`, and because the legacy item is found first a substring
  // check highlights the wrong tab on every v3 URL.
  return currentSection === section || currentSection.startsWith(`${section}/`);
}

export function getActiveTab(navItems: SideBarItemProps[], currentPath: string): string | undefined {
  const currentSection = clientSectionPath(currentPath);
  if (currentSection === null) return undefined;
  const activeNavItem = navItems.find((item) => {
    if (!item.path) return false;
    if (item.title === OVERVIEW_TAB_TITLE) return currentSection === '';
    return (
      sectionMatches(currentSection, item.path) ||
      (item.items?.some((subItem) => sectionMatches(currentSection, subItem.path)) ?? false)
    );
  });
  return activeNavItem?.path || undefined;
}
